import { createSlice } from "@reduxjs/toolkit";

import { fetchProposalActivityFeed } from "./actions";

export const initialState = {
  events: [],
  isLoading: false,
  error: null,
  search: "",
};

const DEFAULT_ERROR = "Failed to load activity";

const proposalActivitySlice = createSlice({
  name: "proposalActivity",
  initialState,
  reducers: {
    setProposalActivitySearch: (state, action) => {
      state.search = action.payload ?? "";
    },
    resetProposalActivityError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProposalActivityFeed.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProposalActivityFeed.fulfilled, (state, action) => {
        state.isLoading = false;
        state.events = action.payload;
      })
      .addCase(fetchProposalActivityFeed.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export const { setProposalActivitySearch, resetProposalActivityError } =
  proposalActivitySlice.actions;

export default proposalActivitySlice.reducer;
